/* MIKOO style quiz. Scores every gallery-wall set on room, style, wall width and budget, then shows
   the top three, each linking to the product with the chosen frame (and a fitting size) selected. */
(function () {
  if (customElements.get('mikoo-quiz')) return;

  var ROOMS = { living: 'תמונות-לסלון', bedroom: 'תמונות-לחדר-שינה', kids: 'סטים-לחדרי-ילדים' };
  var STYLES = { line: ['line-art-collection'], japandi: ['japandi-collection', 'nordic-abstract-collection'], israel: ['israel-collection'] };
  /* matched on the set name only: the product tags are SEO tags added to almost every set */
  var STYLE_WORDS = {
    soft: /light|pastel|gentel|gentle|delicate|pink|peach|rose|soft|boho|hearts|butterfly/i,
    line: /line/i,
    japandi: /japandi|nordic|japanese/i,
    nature: /leaf|leaves|beach|sea|see|flower|natural|palm|cactus|agave|wheat|feuille|fig|bird|stones|animal|safari|forrest|forest|giraffe|hakuna|sky/i,
    bold: /black|gray|grey|paris|brush|marble|whisky|cask/i,
    israel: /israel|exodus|tel aviv/i
  };
  var LABELS = {
    room: { living: 'מתאים לסלון', bedroom: 'מתאים לחדר שינה', kids: 'לחדר ילדים', office: 'מתאים למשרד' },
    style: { soft: 'עדין ובהיר', line: 'ליין ארט', japandi: 'יפני-נורדי', nature: 'טבע', bold: 'שחור-לבן', israel: 'ישראלי' }
  };
  var SIZES = { narrow: ['30x40', '21x30'], medium: ['40x50', '30x40'], wide: ['30x40', '40x50', '21x30'] };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function json(url) { return fetch(url).then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; }); }
  function collectionProducts(handle) { return json('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250').then(function (d) { return d.products || []; }); }
  function handles(products) { var s = {}; products.forEach(function (p) { s[p.handle] = true; }); return s; }
  /* The unframed pictures, from the product's image file names. Usually they end in 1 (framed: 2, room: 3).
     Before comparing, Shopify's _<uuid> and _<n> suffixes for repeated names are removed (a uuid can end in 1).
     When the product has a framed picture ("…2"), only the "…1" with the same name counts (so a room picture
     like "…no131" next to "…no11" / "…no12" is left out). Old uploads with no number: the unframed picture is
     named like the framed one without the 2. Same rule as snippets/mikoo-frame-stage.liquid.
     isPlain(src, all): all = every image of the product (srcs or objects with .src). */
  function stemOf(src) {
    var m = /([^/]+)[.](jpe?g|png|webp)$/i.exec(String(src || '').split('?')[0]);
    return m ? m[1].replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '').replace(/_[0-9]+$/, '') : null;
  }
  function plainStems(all) {
    var stems = (all || []).map(function (x) { return stemOf(typeof x === 'string' ? x : x && (x.src || x.url)); }).filter(Boolean);
    var ones = stems.filter(function (s) { return /1$/.test(s); });
    var bases = stems.filter(function (s) { return /2$/.test(s); }).map(function (s) { return s.slice(0, -1); });
    var matched = ones.filter(function (s) { return bases.indexOf(s.slice(0, -1)) > -1; });
    if (matched.length) return matched;
    if (ones.length) return ones;
    return stems.filter(function (s) { return !/[0-9]$/.test(s) && stems.indexOf(s + '2') > -1; });
  }
  function isPlain(src, all) {
    var stem = stemOf(src);
    return !!stem && plainStems(all && all.length ? all : [src]).indexOf(stem) > -1;
  }
  function money(cents) { var v = cents / 100; return '₪' + v.toLocaleString('he-IL', { maximumFractionDigits: v % 1 ? 2 : 0 }); }
  function cents(price) { return typeof price === 'number' ? price : Math.round(parseFloat(price) * 100); }

  class MikooQuiz extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('.mk-quiz__q'));
      this.answers = {};
      this.index = 0;
      this.back = this.querySelector('.mk-quiz__back');
      var self = this;
      this.steps.forEach(function (step) {
        step.querySelectorAll('.mk-quiz__opt').forEach(function (opt) {
          opt.addEventListener('click', function () { self.choose(step, opt); });
        });
      });
      this.back.addEventListener('click', function () { if (self.index > 0) self.go(self.index - 1, -1); });
      this.querySelector('.mk-quiz__restart').addEventListener('click', function () { self.answers = {}; self.clearSelection(); self.go(0, -1); });
      this.data = this.load(); /* start fetching right away, so results are instant */
      this.progress(0);
      this.startFromLink();
    }

    /* the homepage teaser links here with the first answer (?room=living): choose it and open on question 2 */
    startFromLink() {
      var room = (new URLSearchParams(location.search).get('room') || '').replace(/[^a-z]/g, '');
      var first = this.steps[0];
      var opt = room && first && first.dataset.key === 'room' && first.querySelector('.mk-quiz__opt[data-value="' + room + '"]');
      if (!opt || !this.steps[1]) return;
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');
      this.answers.room = opt.dataset.value;
      first.hidden = true;
      this.steps[1].hidden = false;
      this.index = 1;
      this.back.hidden = false;
      this.progress(1);
    }

    load() {
      var rooms = Object.keys(ROOMS).map(function (k) { return collectionProducts(ROOMS[k]).then(function (p) { return [k, handles(p)]; }); });
      var styles = [];
      Object.keys(STYLES).forEach(function (k) {
        STYLES[k].forEach(function (h) { styles.push(collectionProducts(h).then(function (p) { return [k, handles(p)]; })); });
      });
      return Promise.all([collectionProducts(this.dataset.sets), Promise.all(rooms), Promise.all(styles)]).then(function (r) {
        var roomSets = {}; r[1].forEach(function (x) { roomSets[x[0]] = x[1]; });
        var styleSets = {}; r[2].forEach(function (x) { styleSets[x[0]] = Object.assign(styleSets[x[0]] || {}, x[1]); });
        return { sets: r[0], rooms: roomSets, styles: styleSets };
      });
    }

    clearSelection() { this.querySelectorAll('.mk-quiz__opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); }); }

    choose(step, opt) {
      step.querySelectorAll('.mk-quiz__opt').forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false'); });
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');
      this.answers[step.dataset.key] = opt.dataset.value;
      var self = this;
      /* let the selected state register, then move on */
      clearTimeout(this.advance);
      this.advance = setTimeout(function () { self.go(self.index + 1, 1); }, reduceMotion ? 80 : 220);
    }

    /* forward moves to the left (Hebrew reading direction), back moves to the right */
    go(next, dir) {
      if (next < 0 || next >= this.steps.length || next === this.index) return;
      /* a quick second tap completes the previous swap first, so two questions never show at once */
      if (this.pendingSwap) this.pendingSwap();
      var from = this.steps[this.index];
      var to = this.steps[next];
      this.index = next;
      var shift = reduceMotion ? 0 : 32;
      var self = this;
      var out = from.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + dir * shift + 'px)' }], { duration: reduceMotion ? 120 : 180, easing: 'cubic-bezier(0.4, 0, 1, 1)' });
      var done = false;
      var swap = function () {
        if (done) return;
        done = true;
        self.pendingSwap = null;
        out.cancel();
        from.hidden = true;
        to.hidden = false;
        to.animate([{ opacity: 0, transform: 'translateX(' + -dir * shift + 'px)' }, { opacity: 1, transform: 'none' }], { duration: reduceMotion ? 120 : 280, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        var heading = to.querySelector('.mk-quiz__question');
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        if (to.dataset.key === 'results') self.showResults();
      };
      this.pendingSwap = swap;
      out.onfinish = swap;
      setTimeout(swap, 400); /* never wait on a paused animation (background tab) */
      this.back.hidden = next === 0 || to.dataset.key === 'results';
      this.progress(next);
    }

    progress(i) {
      var total = this.steps.length - 1;
      var done = Math.min(i, total);
      this.querySelector('.mk-quiz__progress-fill').style.transform = 'scaleX(' + done / total + ')';
      this.querySelector('.mk-quiz__step').textContent = i < total ? 'שאלה ' + (i + 1) + ' מתוך ' + total : 'התוצאות מוכנות';
    }

    score(set, d, index, count) {
      var a = this.answers;
      var reasons = [];
      var s = 0;
      var room = a.room;
      var inKids = !!d.rooms.kids[set.handle];
      if (room === 'kids') { s += inKids ? 6 : -8; if (inKids) reasons.push(LABELS.room.kids); }
      else {
        if (inKids) s -= 8;
        if (room === 'office') { s += 2; reasons.push(LABELS.room.office); }
        else if (d.rooms[room] && d.rooms[room][set.handle]) { s += 4; reasons.push(LABELS.room[room]); }
      }

      var style = a.style;
      var words = STYLE_WORDS[style];
      var styleHit = (d.styles[style] && d.styles[style][set.handle]) || (words && words.test(set.handle.replace(/-/g, ' ')));
      if (styleHit) { s += 4; reasons.push(LABELS.style[style]); }

      var n = (set.images || []).filter(function (img, i, all) { return isPlain(img.src, all); }).length || 3;
      set.mkCount = n;
      var w = a.width;
      if (w === 'narrow') s += n === 2 ? 3 : n >= 4 ? -3 : 0;
      if (w === 'medium') s += n <= 3 ? 3 : 0;
      if (w === 'wide') s += n >= 4 ? 4 : n === 3 ? 2 : -2;

      var variant = this.pickVariant(set);
      set.mkVariant = variant;
      var limit = parseInt(a.budget, 10) || 0;
      var price = variant ? cents(variant.price) : 0;
      if (limit) { if (price <= limit) { s += 2; reasons.push('בתקציב'); } else s -= 4; }

      s += (count - index) / count; /* small nudge towards the collection's own order */
      set.mkReasons = reasons;
      return s;
    }

    pickVariant(set) {
      var frame = this.answers.frame;
      var sizes = SIZES[this.answers.width] || SIZES.medium;
      var variants = (set.variants || []).filter(function (v) { return v.available !== false; });
      var withFrame = variants.filter(function (v) { return [v.option1, v.option2, v.option3].indexOf(frame) > -1; });
      var pool = withFrame.length ? withFrame : variants;
      for (var i = 0; i < sizes.length; i++) {
        var size = sizes[i].toLowerCase();
        var hit = pool.filter(function (v) { return [v.option1, v.option2, v.option3].some(function (o) { return o && o.toLowerCase() === size; }); })[0];
        if (hit) return hit;
      }
      return pool[0] || null;
    }

    showResults() {
      var self = this;
      var box = this.querySelector('.mk-quiz__cards');
      box.innerHTML = '<p class="mk-quiz__loading">רגע, בוחרים בשבילכם…</p>';
      this.data.then(function (d) {
        var count = d.sets.length;
        var ranked = d.sets.map(function (set, i) { return { set: set, score: self.score(set, d, i, count) }; })
          .sort(function (a, b) { return b.score - a.score; }).slice(0, 3);
        if (!ranked.length) { box.innerHTML = '<p class="mk-quiz__loading">לא הצלחנו לטעון את הקירות כרגע. נסו שוב בעוד רגע.</p>'; return; }
        box.innerHTML = '';
        if (window.mkTrack) window.mkTrack('mk_quiz_complete');
        ranked.forEach(function (r, i) {
          var set = r.set;
          var v = set.mkVariant;
          var img = (set.images && set.images[0] && set.images[0].src) || '';
          var a = document.createElement('a');
          a.className = 'mk-quiz__card';
          a.href = '/products/' + set.handle + (v ? '?variant=' + v.id : '');
          a.style.setProperty('--i', i);
          a.innerHTML =
            '<img alt="" loading="lazy" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=700">' +
            '<span class="mk-quiz__card-body">' +
            '<span class="mk-quiz__card-title"></span>' +
            '<span class="mk-quiz__card-meta"></span>' +
            '<span class="mk-quiz__chips"></span>' +
            '<span class="mk-quiz__card-go">לצפייה בקיר ‹</span></span>';
          a.querySelector('.mk-quiz__card-title').textContent = set.title;
          var size = v ? [v.option1, v.option2, v.option3].filter(function (o) { return o && /x/i.test(o); })[0] : '';
          a.querySelector('.mk-quiz__card-meta').textContent =
            set.mkCount + ' תמונות' + (v ? ' · ' + money(cents(v.price)) + (size ? ' במידה ' + size : '') : '');
          var chips = a.querySelector('.mk-quiz__chips');
          set.mkReasons.forEach(function (reason) { var c = document.createElement('span'); c.className = 'mk-quiz__chip'; c.textContent = reason; chips.appendChild(c); });
          box.appendChild(a);
        });
      });
    }
  }

  customElements.define('mikoo-quiz', MikooQuiz);
})();
